import { render, staticRenderFns } from "./optionItemImg.vue?vue&type=template&id=295f881b&scoped=true"
import script from "./optionItemImg.vue?vue&type=script&lang=js"
export * from "./optionItemImg.vue?vue&type=script&lang=js"
import style0 from "./optionItemImg.vue?vue&type=style&index=0&id=295f881b&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295f881b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('295f881b')) {
      api.createRecord('295f881b', component.options)
    } else {
      api.reload('295f881b', component.options)
    }
    module.hot.accept("./optionItemImg.vue?vue&type=template&id=295f881b&scoped=true", function () {
      api.rerender('295f881b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/optionItemImg.vue"
export default component.exports